import * as SimpleSwitch from "a-simple-switch"
import PreferencesBaseController from "controllers/preferences_base_controller"

export default class extends PreferencesBaseController {
  _updateUiElement(newValue) {
    SimpleSwitch.toggle(this.element, newValue)
  }

  _getCurrentValue() {
    return this.element.checked
  }
}
